export default __webpack_public_path__ + "static/media/icon-hotel.67a472b7.svg";